<template>
  <div class="menu">
    <div class="row title">
      <h2 v-html="info.title" class="col-6 col-md-12"></h2>
      <div v-html="info.count" class="count col-6 col-md-12"></div>
    </div>
    <!-- <div class="row">
            <InputComponent
              class="col-12 col-md-12"
              id="search"
              name="search"
              :icon="info.search.icon"
              :text-default="info.search.placeholder"
              v-model="search"
              @input="onInputSearch"
              :valid="true"
              :class="[{}]"
            />
        </div>-->

    <ul class="category-list">
      <li
        class="category-item"
        v-for="(v, i) in categories.list"
        :key="i"
        :class="[{ expanded: currentCategory == v.id }]"
      >
        <div class="category-container">
          <router-link
            tag="a"
            class="nav-arrow nav-arrow--expand"
            :to="'product?cat=' + v.id"
          ></router-link>
          <div>
            <router-link
              class="category-link"
              :to="'product?cat=' + v.id"
              tag="a"
              ref="category"
              v-html="v.title"
            ></router-link>
          </div>
        </div>

        <ul class="subcategory-list">
          <li
            class="subcategory-item"
            v-for="(s, j) in getSubcategories(v.id)"
            :key="j"
            :class="[{ current: currentSubcategory === s.id }]"
          >
            <div>
              <router-link
                class="subcategory-link"
                :class="[
                  s.iconsrc ? 'img-icon' : s.icon,
                  { current: currentSubcategory === s.id },
                ]"
                :to="'product?cat=' + v.id + '&subcat=' + s.id"
                tag="a"
                ref="subcategory"
                v-html="
                  (s.iconsrc
                    ? `<span class='icon' style='background-image:url(${
                        s.iconsrc
                      })'></span>`
                    : '') + s.title
                "
              ></router-link>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import utils from "../utils";
export default {
  name: "Categories",
  props: {
    info: Object,
    categories: Object,
    list: Array,
  },
  data() {
    return {
      utils: utils,
      currentCategory: 1,
      currentSubcategory: 1,
    };
  },
  methods: {
    getSubcategories(id) {
      return this.categories.subcategories.list.filter(
        item => item.category === id
      );
    },
  },
  watch: {
    $route(to) {
      this.currentSubcategory = parseInt(to.query.subcat);
      this.currentCategory = parseInt(to.query.cat);
    },
  },
  mounted() {
    this.currentSubcategory = parseInt(this.$route.query.subcat);
    this.currentCategory = parseInt(this.$route.query.cat);
  },
};
</script>

<style lang="scss">
.count {
  @extend %strip;
  align-self: center;
  justify-self: flex-start;
  padding: 0 20px;
  line-height: 24px;
}
.category-list {
  display: grid;
  grid-gap: 32px;
  margin: 0;
  margin-top: 38px;
  .category-item {
    @media all and (max-width: $md) {
      margin-bottom: -18px;
    }
    display: grid;
    grid-gap: 12px;
    .category-container {
      @media all and (max-width: $md) {
        grid-template-columns: 36px auto;
        grid-gap: 16px;
        align-items: center;
      }
      display: grid;
      grid-template-columns: auto;
    }
    .nav-arrow {
      @media all and (max-width: $md) {
        display: grid;
      }
      grid-column: 1;
      display: none;
      &::before {
        transition: all 0.5s;
        transform: rotate(-90deg);
      }
    }

    .subcategory-list {
      transition: all 0.5s;
      @media all and (max-width: $md) {
        max-height: 0;
        grid-gap: 0;
        overflow: hidden;
        padding-left: 54px;
      }
      margin: 0;
      display: grid;
      grid-gap: 0;
      .subcategory-item {
        display: grid;
        position: relative;
      }
      .subcategory-link {
        @extend %text-small;
        padding: 10px 0;
        display: block;
        &.img-icon {
          span {
            margin-top: 0px;
            align-self: center;
            position: absolute;
            left: -60px;
            transition: left 0.5s, opacity 0.5s;
            opacity: 0;
            // transform: scale(0.5);
            display: inline-block;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: top center;
            width: 18px;
            height: 18px;
            font-size: 18px;
            color: $color-error;
          }
          &:hover {
            span {
              left: 0px;
              opacity: 1;
            }
          }
        }
        &::before {
          margin-top: -3px;
          align-self: center;
          position: absolute;
          left: -60px;
          transition: left 0.5s, opacity 0.5s;
          opacity: 0;
          // transform: scale(0.5);
          display: inline-block;
          width: 18px;
          font-size: 18px;
          color: $color-error;
        }
        &:hover {
          border-color: transparent;
          color: $color-accent;

          padding-left: 31px;
          &::before {
            left: 0px;
            opacity: 1;
          }
        }
        &.current {
          color: $text-main-quart;
        }
      }
    }
    &.expanded {
      .subcategory-list {
        @media all and (max-width: $md) {
          max-height: 300px;
          overflow: hidden;
        }
      }

      .nav-arrow {
        grid-column: 1;
        &::before {
          transform: rotate(90deg);
        }
      }
    }
  }
  .category-link {
    font-size: 18px;
  }
  a {
    transition: all 0.5s;
    &:hover {
      border-color: transparent;
      color: $color-accent;
    }
  }
}
</style>
